import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";
import { getPostById, editPostById } from "./request";
import { TextField, Button, Box, Stack } from "@mui/material";
import { useNavigate } from "react-router";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML, convertFromHTML } from "draft-convert";
import "./index.css";

const EditPost = ({ accessToken }) => {
    const [editorState, setEditorState] = useState(() =>
        EditorState.createEmpty()
    );
    const [title, setTitle] = useState("");
    const navigate = useNavigate();

    const params = useParams();

    useEffect(() => {
        (async () => {
            const post = await getPostById({ _id: params._id });
            setEditorState(() =>
                EditorState.createWithContent(convertFromHTML(post.content))
            );
            setTitle(post.title);
        })();
    }, []);

    const [convertedContent, setConvertedContent] = useState(null);

    useEffect(() => {
        setConvertedContent(convertToHTML(editorState.getCurrentContent()));
    }, [editorState]);

    const onTitleChange = (e) => {
        setTitle(e.target.value);
    };

    const onSubmit = async () => {
        await editPostById({
            _id: params._id,
            accessToken,
            content: convertedContent,
            title,
        });
        navigate("/admin");
    };

    const onSave = async () => {
        await editPostById({
            _id: params._id,
            accessToken,
            content: convertedContent,
            title,
        });
    };

    return (
        <Box
            sx={{ p: 2, border: "1px dashed grey", justifyContent: "center" }}
            className="post-editor"
        >
            <Stack spacing={2}>
                <TextField
                    label="Title"
                    value={title}
                    onChange={onTitleChange}
                ></TextField>
                <Editor
                    multiline
                    rows={15}
                    editorState={editorState}
                    onEditorStateChange={setEditorState}
                    wrapperClassName="wrapper-class"
                    editorClassName="editor-class"
                    toolbarClassName="toolbar-class"
                />
                <Button onClick={onSave} variant="contained">
                    Save
                </Button>
                <Button onClick={onSubmit} variant="contained">
                    Post
                </Button>
            </Stack>
        </Box>
    );
};

const mapStateToProps = (state) => ({
    accessToken: state.user.accessToken,
});

export default connect(mapStateToProps)(EditPost);
